function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.17,313.63c46.24,53,92.93,59.71,158.56,72.27s113.82,3.88,149.33-28.13c41-37,39.38-121.76-23.36-151.94-19.6-9.45-42.94-12.31-60.11-25.6C289.8,154.87,263.28,115.41,210.64,108s-88.13,27.9-88.13,27.9C79.28,183.24,51.93,260.59,98.17,313.63Z",
    style: {
      fill: "#D26363"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.17,313.63c46.24,53,92.93,59.71,158.56,72.27s113.82,3.88,149.33-28.13c41-37,39.38-121.76-23.36-151.94-19.6-9.45-42.94-12.31-60.11-25.6C289.8,154.87,263.28,115.41,210.64,108s-88.13,27.9-88.13,27.9C79.28,183.24,51.93,260.59,98.17,313.63Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.95,
    y: 398.38,
    width: 390,
    height: 16,
    style: {
      fill: "#D26363"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.95,
    y: 398.38,
    width: 390,
    height: 16,
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.92,226.29a56,56,0,0,0-5.61,2.17c1-.73,2-1.49,3-2.26A145.46,145.46,0,0,0,163,214.7a138.06,138.06,0,0,1-15,12.63,31.86,31.86,0,0,0,1.92-3.94c1-2.49,1.18-5-1.19-6.33-2.93-1.64-6.47.81-5.54,5a15.46,15.46,0,0,0,3.23,6.35,95.78,95.78,0,0,1-10.8,6.47l-.35.18a35.61,35.61,0,0,0,2.09-4.25c.94-2.48,1.18-5-1.2-6.32-2.93-1.65-6.47.81-5.53,5a15.49,15.49,0,0,0,3.16,6.28c-4.49,2.21-9.13,4.09-13.75,6.13l-.67.3a30.82,30.82,0,0,0,2.51-3.07c1.5-2.2,2.31-4.58.31-6.43-2.46-2.28-6.49-.72-6.55,3.6a15.45,15.45,0,0,0,1.62,6.87A70.69,70.69,0,0,0,105,250.49l-.12.1a27.44,27.44,0,0,0,1.42-2.54c1.13-2.41,1.55-4.89-.73-6.4a3.72,3.72,0,0,0-5.58,1.73,3.51,3.51,0,0,0-1.19-1.14c-2.29-1.32-4.54.11-6.47,2.13-.5.53-1,1.1-1.43,1.66a70.54,70.54,0,0,1,5.59-11.9,17.11,17.11,0,0,0,6.73,1.43c4.56,0,6.48-3.8,4.24-6.16-1.82-1.91-4.38-1.18-6.8.22a25.56,25.56,0,0,0-2.31,1.52,69.14,69.14,0,0,1,7.86-9.78,17.13,17.13,0,0,0,6.5,3.27c4.43,1.09,7.21-2.12,5.61-4.95-1.3-2.3-4-2.21-6.65-1.44a30.74,30.74,0,0,0-3.72,1.38c1.21-1.18,2.46-2.31,3.73-3.43,1.66-1.42,3.38-2.79,5.13-4.13a17.09,17.09,0,0,0,6.39,3.19c4.43,1.09,7.21-2.12,5.61-4.95-1.3-2.3-4-2.21-6.66-1.44-.62.18-1.25.4-1.86.63,2.31-1.65,4.65-3.26,7-4.86l2.17-1.49a17.18,17.18,0,0,0,6.72,3.46c4.43,1.09,7.22-2.12,5.62-4.95-1.31-2.3-4-2.21-6.66-1.44q-1.57.48-3.09,1.11h0l1.34-1c.82-.59,1.64-1.19,2.44-1.82,1-.75,1.95-1.58,2.92-2.38.56-.44,1.09-.91,1.62-1.39a17.13,17.13,0,0,0,6.76,3.49c4.43,1.09,7.21-2.12,5.61-4.95-1.3-2.3-4-2.21-6.65-1.44a37.55,37.55,0,0,0-4.36,1.65h0c1.81-1.68,3.56-3.43,5.22-5.25.11-.13.21-.26.33-.38.71-.79,1.41-1.59,2.09-2.42s1.56-1.92,2.3-2.92a57.23,57.23,0,0,0,7.44-13,57,57,0,0,1-7.69,12.8,80.47,80.47,0,0,1-10.27,10.85l-.41.35A38,38,0,0,0,143,189c.95-2.48,1.18-5-1.2-6.32-2.92-1.65-6.47.81-5.53,5a15.55,15.55,0,0,0,3.51,6.68l-.88.76-1,.86c-.58.47-1.18.92-1.78,1.37-.32.24-.63.49-1,.73-.85.63-1.71,1.24-2.58,1.84l-1.25.85-1.42,1a34.73,34.73,0,0,0,2.18-4.41c.95-2.49,1.18-5-1.19-6.32-2.93-1.65-6.48.81-5.54,5a15.47,15.47,0,0,0,3.35,6.51l-1,.68-3.89,2.55-.77.5-2.17,1.45-.94.63c-1,.69-2,1.39-3,2.11A35.3,35.3,0,0,0,119,206c1-2.48,1.18-5-1.19-6.32-2.93-1.65-6.47.81-5.53,5a15.41,15.41,0,0,0,3.42,6.58c-1.7,1.25-3.38,2.53-5,3.87-1.19,1-2.36,2-3.51,3.08a27.54,27.54,0,0,0,1.34-2.86c.94-2.49,1.18-5-1.2-6.32-2.93-1.65-6.47.81-5.53,5a15.49,15.49,0,0,0,3.16,6.28,70.22,70.22,0,0,0-8.71,10.53,26.71,26.71,0,0,0,.66-3.32c.32-2.64-.06-5.12-2.69-5.84-3.24-.89-6.08,2.35-4.15,6.21a15.49,15.49,0,0,0,4.64,5.37,72.78,72.78,0,0,0-6.28,13,26.84,26.84,0,0,0-.28-2.83c-.45-2.63-1.51-4.9-4.24-4.85-3.36.07-5.17,4-2.22,7.14a15.24,15.24,0,0,0,5.62,3.71,91.35,91.35,0,0,0-2.77,10.67c-.12.57-.21,1.14-.32,1.71-.12.11-.24.22-.35.34-.12-.49-.26-1-.42-1.47-.84-2.52-2.24-4.61-4.93-4.13-3.3.58-4.49,4.72-1.09,7.39a15.13,15.13,0,0,0,5.84,2.73c0,.1.08.19.13.29-.37,2.71-.65,5.44-.82,8.18-.13,2-.2,4.09-.24,6.14-2.86,0-4.88,3.14-2.91,6.54a14.42,14.42,0,0,0,3.15,3.72c.24,3.85.62,7.7,1.13,11.52a3.17,3.17,0,0,0-3.06-.71c-1.8.49-2.61,1.94-2.9,3.72a3.56,3.56,0,0,0-1,2.47c-1.34-2-2.61-4-3.84-6.11a17,17,0,0,0,4.57-5.33c2.15-4-.28-7.51-3.41-6.66-2.56.7-3.12,3.3-3,6.09a27.92,27.92,0,0,0,.3,3.16l-1.32-2.32c-1.1-2-2-4-3.08-6-.26-.49-.49-1-.7-1.5a17,17,0,0,0,5.47-4.37c2.87-3.54,1.14-7.43-2.1-7.18-2.64.21-3.69,2.66-4.13,5.42a34,34,0,0,0-.32,3.63l-.94-2.17a111.49,111.49,0,0,1-4.93-15.14,17,17,0,0,0,6.34-4c3.21-3.25,1.88-7.28-1.37-7.36-2.64-.06-3.93,2.27-4.65,5a36.54,36.54,0,0,0-.79,4.4q-1.05-4.44-1.8-9c-.34-1.86-.56-3.75-.79-5.63a17.24,17.24,0,0,0,7.06-3.17c3.6-2.8,2.81-7-.41-7.47-2.61-.41-4.19,1.74-5.25,4.33a43.22,43.22,0,0,0-1.56,5c-.2-2.18-.43-4.37-.53-6.56a102.57,102.57,0,0,1,0-13.58,102.93,102.93,0,0,0-.47,13.6c0,2.09.18,4.17.31,6.26a33.43,33.43,0,0,0-2-4.13c-1.36-2.29-3.18-4-5.7-3-3.11,1.28-3.38,5.58.52,7.46a15.48,15.48,0,0,0,7.31,1.39c.18,1.87.34,3.73.62,5.58.39,3,.89,5.88,1.48,8.79a29.76,29.76,0,0,0-2.13-3.21c-1.65-2.09-3.67-3.57-6-2.22-2.91,1.67-2.63,6,1.48,7.33a15.5,15.5,0,0,0,7.19.48,115.73,115.73,0,0,0,4.49,15.35l.59,1.5a21.73,21.73,0,0,0-1.71-2c-1.85-1.92-4-3.19-6.23-1.6-2.73,2-2,6.2,2.2,7.14a15.47,15.47,0,0,0,7-.2c.21.51.42,1,.67,1.52,1,2.06,1.89,4.17,2.94,6.19L69,300c-.52-.45-1.06-.88-1.62-1.28-2.18-1.53-4.54-2.37-6.42-.4-2.32,2.43-.82,6.47,3.5,6.6A15.31,15.31,0,0,0,71,303.62c1.24,2.24,2.51,4.45,3.89,6.62.51.83,1,1.65,1.58,2.47a25.7,25.7,0,0,0-2.48-2c-2.18-1.53-4.54-2.37-6.43-.4-2.31,2.43-.81,6.47,3.51,6.6a15.55,15.55,0,0,0,7.12-1.63q1.08,1.5,2.22,3c-1.61,1.87-1.08,5,2.19,6.43a14.59,14.59,0,0,0,5,1.11c.2.16.4.32.62.47l.1.08q3.1,11.58,7.35,22.82c1.2,3.19,2.49,6.35,3.82,9.49h-12V406h36.67V358.64H104.64c-1.67-3.65-3.28-7.34-4.78-11.07-2.45-6.12-4.67-12.34-6.6-18.65h0a8.52,8.52,0,0,0,1,.23,4.36,4.36,0,0,0,1.35.06l-.52-3.29h-.35a6.18,6.18,0,0,1-.62-.12,9.53,9.53,0,0,1-1.35-.5l-.52-.24a16.93,16.93,0,0,0,5.29-3c3.47-3,2.49-7.1-.75-7.45-2.62-.29-4.1,1.93-5,4.56-.27.75-.49,1.53-.68,2.29-.19-.7-.38-1.4-.56-2.1-.53-2.07-1-4.16-1.48-6.25A16.83,16.83,0,0,0,94.8,310c3.47-3,2.48-7.09-.75-7.44-2.63-.29-4.1,1.93-5,4.56-.27.76-.5,1.55-.7,2.33-.3-1.52-.59-3.05-.86-4.58-.19-1.13-.37-2.27-.54-3.41-.06-1.62-.09-3.24-.07-4.87,0-.89,0-1.78.08-2.67a17.1,17.1,0,0,0,6.07.77c4.56-.3,6.24-4.2,3.86-6.41-1.94-1.81-4.45-.91-6.78.63a31.89,31.89,0,0,0-3,2.31,73.1,73.1,0,0,1,1.73-11.3,57.69,57.69,0,0,1,1.91-6.46,17.13,17.13,0,0,0,6.51.91c4.56-.29,6.24-4.19,3.86-6.41-1.93-1.8-4.45-.91-6.78.64A26.3,26.3,0,0,0,92,270.41a48.36,48.36,0,0,1,3.06-6A44.09,44.09,0,0,1,103.6,254a16.91,16.91,0,0,0,6.05,3.59c4.34,1.42,7.35-1.58,6-4.52-1.13-2.39-3.79-2.5-6.53-1.93A27.66,27.66,0,0,0,106,252l.07-.06a69,69,0,0,1,12-7.52,17.21,17.21,0,0,0,5.58,4.74c4.06,2.09,7.51-.39,6.61-3.51-.73-2.54-3.34-3.07-6.13-3a29.72,29.72,0,0,0-3.27.36c4.51-2.13,9.11-4.14,13.55-6.49h0l.1,0a17,17,0,0,0,6.89,3.6c4.43,1.1,7.21-2.12,5.61-5-1.3-2.3-4-2.2-6.65-1.44-.75.22-1.5.49-2.23.77a99.31,99.31,0,0,0,8.61-5.62l.23.25,0-.13a17.36,17.36,0,0,0,6.95,3.65c4.42,1.09,7.21-2.12,5.61-5C158.27,225.43,155.61,225.52,152.92,226.29ZM83,316.9c-.91-1.06-1.77-2.17-2.61-3.29.2-.18.42-.38.64-.6a15.72,15.72,0,0,0,3.85.69v.21l.61-.13c.32,1.58.65,3.15,1,4.72A4.09,4.09,0,0,0,83,316.9Zm3.26-37.65c-.31,1.18-.57,2.36-.82,3.55l-.15-.21q0-3.66.11-7.3c.07-1.7.19-3.39.34-5.09a17.62,17.62,0,0,0,2.7,2.25,65.51,65.51,0,0,0-2.17,6.8Zm4.1-11.2c.06-.44.11-.89.13-1.33v-.67c.36-.11.73-.24,1.09-.39-.4.79-.82,1.59-1.21,2.39Zm5.21-8.45a3.19,3.19,0,0,0-1.83-1.72c-2.47-1-4.47.8-6.06,3.1l-.08.11h-.16a3,3,0,0,0-.51-.07.83.83,0,0,1,.07-.41,89.35,89.35,0,0,1,2.56-10.69,17,17,0,0,0,6.85-.53A5.83,5.83,0,0,0,99.77,247a15.44,15.44,0,0,0,2.47,5.61,45.89,45.89,0,0,0-6.66,7Z",
    style: {
      fill: "#D26363"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.92,226.29a56,56,0,0,0-5.61,2.17c1-.73,2-1.49,3-2.26A145.46,145.46,0,0,0,163,214.7a138.06,138.06,0,0,1-15,12.63,31.86,31.86,0,0,0,1.92-3.94c1-2.49,1.18-5-1.19-6.33-2.93-1.64-6.47.81-5.54,5a15.46,15.46,0,0,0,3.23,6.35,95.78,95.78,0,0,1-10.8,6.47l-.35.18a35.61,35.61,0,0,0,2.09-4.25c.94-2.48,1.18-5-1.2-6.32-2.93-1.65-6.47.81-5.53,5a15.49,15.49,0,0,0,3.16,6.28c-4.49,2.21-9.13,4.09-13.75,6.13l-.67.3a30.82,30.82,0,0,0,2.51-3.07c1.5-2.2,2.31-4.58.31-6.43-2.46-2.28-6.49-.72-6.55,3.6a15.45,15.45,0,0,0,1.62,6.87A70.69,70.69,0,0,0,105,250.49l-.12.1a27.44,27.44,0,0,0,1.42-2.54c1.13-2.41,1.55-4.89-.73-6.4a3.72,3.72,0,0,0-5.58,1.73,3.51,3.51,0,0,0-1.19-1.14c-2.29-1.32-4.54.11-6.47,2.13-.5.53-1,1.1-1.43,1.66a70.54,70.54,0,0,1,5.59-11.9,17.11,17.11,0,0,0,6.73,1.43c4.56,0,6.48-3.8,4.24-6.16-1.82-1.91-4.38-1.18-6.8.22a25.56,25.56,0,0,0-2.31,1.52,69.14,69.14,0,0,1,7.86-9.78,17.13,17.13,0,0,0,6.5,3.27c4.43,1.09,7.21-2.12,5.61-4.95-1.3-2.3-4-2.21-6.65-1.44a30.74,30.74,0,0,0-3.72,1.38c1.21-1.18,2.46-2.31,3.73-3.43,1.66-1.42,3.38-2.79,5.13-4.13a17.09,17.09,0,0,0,6.39,3.19c4.43,1.09,7.21-2.12,5.61-4.95-1.3-2.3-4-2.21-6.66-1.44-.62.18-1.25.4-1.86.63,2.31-1.65,4.65-3.26,7-4.86l2.17-1.49a17.18,17.18,0,0,0,6.72,3.46c4.43,1.09,7.22-2.12,5.62-4.95-1.31-2.3-4-2.21-6.66-1.44q-1.57.48-3.09,1.11h0l1.34-1c.82-.59,1.64-1.19,2.44-1.82,1-.75,1.95-1.58,2.92-2.38.56-.44,1.09-.91,1.62-1.39a17.13,17.13,0,0,0,6.76,3.49c4.43,1.09,7.21-2.12,5.61-4.95-1.3-2.3-4-2.21-6.65-1.44a37.55,37.55,0,0,0-4.36,1.65h0c1.81-1.68,3.56-3.43,5.22-5.25.11-.13.21-.26.33-.38.71-.79,1.41-1.59,2.09-2.42s1.56-1.92,2.3-2.92a57.23,57.23,0,0,0,7.44-13,57,57,0,0,1-7.69,12.8,80.47,80.47,0,0,1-10.27,10.85l-.41.35A38,38,0,0,0,143,189c.95-2.48,1.18-5-1.2-6.32-2.92-1.65-6.47.81-5.53,5a15.55,15.55,0,0,0,3.51,6.68l-.88.76-1,.86c-.58.47-1.18.92-1.78,1.37-.32.24-.63.49-1,.73-.85.63-1.71,1.24-2.58,1.84l-1.25.85-1.42,1a34.73,34.73,0,0,0,2.18-4.41c.95-2.49,1.18-5-1.19-6.32-2.93-1.65-6.48.81-5.54,5a15.47,15.47,0,0,0,3.35,6.51l-1,.68-3.89,2.55-.77.5-2.17,1.45-.94.63c-1,.69-2,1.39-3,2.11A35.3,35.3,0,0,0,119,206c1-2.48,1.18-5-1.19-6.32-2.93-1.65-6.47.81-5.53,5a15.41,15.41,0,0,0,3.42,6.58c-1.7,1.25-3.38,2.53-5,3.87-1.19,1-2.36,2-3.51,3.08a27.54,27.54,0,0,0,1.34-2.86c.94-2.49,1.18-5-1.2-6.32-2.93-1.65-6.47.81-5.53,5a15.49,15.49,0,0,0,3.16,6.28,70.22,70.22,0,0,0-8.71,10.53,26.71,26.71,0,0,0,.66-3.32c.32-2.64-.06-5.12-2.69-5.84-3.24-.89-6.08,2.35-4.15,6.21a15.49,15.49,0,0,0,4.64,5.37,72.78,72.78,0,0,0-6.28,13,26.84,26.84,0,0,0-.28-2.83c-.45-2.63-1.51-4.9-4.24-4.85-3.36.07-5.17,4-2.22,7.14a15.24,15.24,0,0,0,5.62,3.71,91.35,91.35,0,0,0-2.77,10.67c-.12.57-.21,1.14-.32,1.71-.12.11-.24.22-.35.34-.12-.49-.26-1-.42-1.47-.84-2.52-2.24-4.61-4.93-4.13-3.3.58-4.49,4.72-1.09,7.39a15.13,15.13,0,0,0,5.84,2.73c0,.1.08.19.13.29-.37,2.71-.65,5.44-.82,8.18-.13,2-.2,4.09-.24,6.14-2.86,0-4.88,3.14-2.91,6.54a14.42,14.42,0,0,0,3.15,3.72c.24,3.85.62,7.7,1.13,11.52a3.17,3.17,0,0,0-3.06-.71c-1.8.49-2.61,1.94-2.9,3.72a3.56,3.56,0,0,0-1,2.47c-1.34-2-2.61-4-3.84-6.11a17,17,0,0,0,4.57-5.33c2.15-4-.28-7.51-3.41-6.66-2.56.7-3.12,3.3-3,6.09a27.92,27.92,0,0,0,.3,3.16l-1.32-2.32c-1.1-2-2-4-3.08-6-.26-.49-.49-1-.7-1.5a17,17,0,0,0,5.47-4.37c2.87-3.54,1.14-7.43-2.1-7.18-2.64.21-3.69,2.66-4.13,5.42a34,34,0,0,0-.32,3.63l-.94-2.17a111.49,111.49,0,0,1-4.93-15.14,17,17,0,0,0,6.34-4c3.21-3.25,1.88-7.28-1.37-7.36-2.64-.06-3.93,2.27-4.65,5a36.54,36.54,0,0,0-.79,4.4q-1.05-4.44-1.8-9c-.34-1.86-.56-3.75-.79-5.63a17.24,17.24,0,0,0,7.06-3.17c3.6-2.8,2.81-7-.41-7.47-2.61-.41-4.19,1.74-5.25,4.33a43.22,43.22,0,0,0-1.56,5c-.2-2.18-.43-4.37-.53-6.56a102.57,102.57,0,0,1,0-13.58,102.93,102.93,0,0,0-.47,13.6c0,2.09.18,4.17.31,6.26a33.43,33.43,0,0,0-2-4.13c-1.36-2.29-3.18-4-5.7-3-3.11,1.28-3.38,5.58.52,7.46a15.48,15.48,0,0,0,7.31,1.39c.18,1.87.34,3.73.62,5.58.39,3,.89,5.88,1.48,8.79a29.76,29.76,0,0,0-2.13-3.21c-1.65-2.09-3.67-3.57-6-2.22-2.91,1.67-2.63,6,1.48,7.33a15.5,15.5,0,0,0,7.19.48,115.73,115.73,0,0,0,4.49,15.35l.59,1.5a21.73,21.73,0,0,0-1.71-2c-1.85-1.92-4-3.19-6.23-1.6-2.73,2-2,6.2,2.2,7.14a15.47,15.47,0,0,0,7-.2c.21.51.42,1,.67,1.52,1,2.06,1.89,4.17,2.94,6.19L69,300c-.52-.45-1.06-.88-1.62-1.28-2.18-1.53-4.54-2.37-6.42-.4-2.32,2.43-.82,6.47,3.5,6.6A15.31,15.31,0,0,0,71,303.62c1.24,2.24,2.51,4.45,3.89,6.62.51.83,1,1.65,1.58,2.47a25.7,25.7,0,0,0-2.48-2c-2.18-1.53-4.54-2.37-6.43-.4-2.31,2.43-.81,6.47,3.51,6.6a15.55,15.55,0,0,0,7.12-1.63q1.08,1.5,2.22,3c-1.61,1.87-1.08,5,2.19,6.43a14.59,14.59,0,0,0,5,1.11c.2.16.4.32.62.47l.1.08q3.1,11.58,7.35,22.82c1.2,3.19,2.49,6.35,3.82,9.49h-12V406h36.67V358.64H104.64c-1.67-3.65-3.28-7.34-4.78-11.07-2.45-6.12-4.67-12.34-6.6-18.65h0a8.52,8.52,0,0,0,1,.23,4.36,4.36,0,0,0,1.35.06l-.52-3.29h-.35a6.18,6.18,0,0,1-.62-.12,9.53,9.53,0,0,1-1.35-.5l-.52-.24a16.93,16.93,0,0,0,5.29-3c3.47-3,2.49-7.1-.75-7.45-2.62-.29-4.1,1.93-5,4.56-.27.75-.49,1.53-.68,2.29-.19-.7-.38-1.4-.56-2.1-.53-2.07-1-4.16-1.48-6.25A16.83,16.83,0,0,0,94.8,310c3.47-3,2.48-7.09-.75-7.44-2.63-.29-4.1,1.93-5,4.56-.27.76-.5,1.55-.7,2.33-.3-1.52-.59-3.05-.86-4.58-.19-1.13-.37-2.27-.54-3.41-.06-1.62-.09-3.24-.07-4.87,0-.89,0-1.78.08-2.67a17.1,17.1,0,0,0,6.07.77c4.56-.3,6.24-4.2,3.86-6.41-1.94-1.81-4.45-.91-6.78.63a31.89,31.89,0,0,0-3,2.31,73.1,73.1,0,0,1,1.73-11.3,57.69,57.69,0,0,1,1.91-6.46,17.13,17.13,0,0,0,6.51.91c4.56-.29,6.24-4.19,3.86-6.41-1.93-1.8-4.45-.91-6.78.64A26.3,26.3,0,0,0,92,270.41a48.36,48.36,0,0,1,3.06-6A44.09,44.09,0,0,1,103.6,254a16.91,16.91,0,0,0,6.05,3.59c4.34,1.42,7.35-1.58,6-4.52-1.13-2.39-3.79-2.5-6.53-1.93A27.66,27.66,0,0,0,106,252l.07-.06a69,69,0,0,1,12-7.52,17.21,17.21,0,0,0,5.58,4.74c4.06,2.09,7.51-.39,6.61-3.51-.73-2.54-3.34-3.07-6.13-3a29.72,29.72,0,0,0-3.27.36c4.51-2.13,9.11-4.14,13.55-6.49h0l.1,0a17,17,0,0,0,6.89,3.6c4.43,1.1,7.21-2.12,5.61-5-1.3-2.3-4-2.2-6.65-1.44-.75.22-1.5.49-2.23.77a99.31,99.31,0,0,0,8.61-5.62l.23.25,0-.13a17.36,17.36,0,0,0,6.95,3.65c4.42,1.09,7.21-2.12,5.61-5C158.27,225.43,155.61,225.52,152.92,226.29ZM83,316.9c-.91-1.06-1.77-2.17-2.61-3.29.2-.18.42-.38.64-.6a15.72,15.72,0,0,0,3.85.69v.21l.61-.13c.32,1.58.65,3.15,1,4.72A4.09,4.09,0,0,0,83,316.9Zm3.26-37.65c-.31,1.18-.57,2.36-.82,3.55l-.15-.21q0-3.66.11-7.3c.07-1.7.19-3.39.34-5.09a17.62,17.62,0,0,0,2.7,2.25,65.51,65.51,0,0,0-2.17,6.8Zm4.1-11.2c.06-.44.11-.89.13-1.33v-.67c.36-.11.73-.24,1.09-.39-.4.79-.82,1.59-1.21,2.39Zm5.21-8.45a3.19,3.19,0,0,0-1.83-1.72c-2.47-1-4.47.8-6.06,3.1l-.08.11h-.16a3,3,0,0,0-.51-.07.83.83,0,0,1,.07-.41,89.35,89.35,0,0,1,2.56-10.69,17,17,0,0,0,6.85-.53A5.83,5.83,0,0,0,99.77,247a15.44,15.44,0,0,0,2.47,5.61,45.89,45.89,0,0,0-6.66,7Z",
    style: {
      fill: "#fff",
      opacity: 0.3,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.49,362.37s-4.84-10.81-6-11.92-10.43-4.47-13-13-7.45-31.3,4.85-29.81,9.31,25.34,13.78,24.59-3.72-38.74,4.1-44,20.49-.37,19,19.75-4.47,31.66-1.86,30.55,10.06-5.22,10.06,3.35-7.08,14.53-11.18,14.9-6,.75-6,.75v5.58Z",
    style: {
      fill: "#2e353a",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.55,341.42c-2.81-2.66-5.39-5.24-6.58-7.61-2.36-4.73-4.14-18-4.14-18",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.64,322.29c1.86,7.75,2.12,13.59,7.74,20.39,3,3.68,10.94,6.8,11.83,10.05A118.05,118.05,0,0,1,402,364.56l4.44.3s.9-7.7-1.64-13.19",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.88,309.86s-3.32,2.55-2.14,8.83",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.15,
    y1: 332.73,
    x2: 401.39,
    y2: 335.58,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.76,
    y1: 331.74,
    x2: 403.15,
    y2: 332.73,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.67,289.16s-6.8-.29-6.8,6.21c0,5.49,1.68,24.23,1.32,32.8",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415,342.41c-.16,2.23-.26,3.81-.26,4.41,0,3.25,8.27-9.17,12.12-9.46,0,0,3.84-.3,2.36,6.8a14.78,14.78,0,0,1-10.34,11.23c-3.26.89-5.92-.59-6.51.89a27.38,27.38,0,0,0-.89,5.32",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.93,295.33a26.26,26.26,0,0,1,.72,6.55c0,6.92-1.32,23.24-2.2,34.26",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.51,289.76a5.24,5.24,0,0,1,2.07,2.18",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 408.7,
    y1: 340.61,
    x2: 408.49,
    y2: 344.75,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.26,293.3s-1.77.59-1.18,6.8c.49,5.13,0,28.42-.23,36.37",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.89,339.13a23.92,23.92,0,0,1-11.53,10.65c-8,3.25-8.28,1.77-8.28,5s-.3,9.17-.3,9.17",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "417.8 405.97 391.96 405.97 386.43 368.54 423.33 368.54 417.8 405.97",
    style: {
      fill: "#D26363",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.26,
    y: 362.64,
    width: 43.24,
    height: 10.02,
    style: {
      fill: "#D26363",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275.92,380.77V360.45H216.08v20.32A29.43,29.43,0,0,1,209.72,399l-2.62,3.3h77.8l-2.62-3.3A29.43,29.43,0,0,1,275.92,380.77Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.4,395h67.2a29.38,29.38,0,0,1-3.68-14.23V360.45H216.08v20.32A29.38,29.38,0,0,1,212.4,395Z",
    style: {
      fill: "#D26363"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.74,
    y: 186.47,
    width: 240.51,
    height: 180.39,
    rx: 8.48,
    style: {
      fill: "#2e353a",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.74,338.82H366.26v19.55a8.48,8.48,0,0,1-8.48,8.48H134.23a8.48,8.48,0,0,1-8.48-8.48h0V338.82Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.84,
    y: 197.7,
    width: 216.32,
    height: 127.44,
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.44,352.84a4.44,4.44,0,1,0-4.44,4.44,4.44,4.44,0,0,0,4.44-4.44Z",
    style: {
      fill: "#2e353a",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.1,
    y: 402.34,
    width: 77.81,
    height: 3.63,
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.54,
    y: 206.68,
    width: 212.59,
    height: 11.17,
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.62 217.85 172.07 210.95 139.54 210.95 139.54 217.85 139.54 227 139.54 319.71 352.13 319.71 352.13 217.85 174.62 217.85",
    style: {
      fill: "#D26363",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 196.76,
    y1: 268.36,
    x2: 296.44,
    y2: 268.36,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 196.76,
    y1: 278.16,
    x2: 296.44,
    y2: 278.16,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 196.76,
    y1: 287.96,
    x2: 296.44,
    y2: 287.96,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 196.76,
    y1: 297.77,
    x2: 296.44,
    y2: 297.77,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.17,242.23H200.84a7.08,7.08,0,0,1-7.09-7.07v0h0a7.08,7.08,0,0,1,7.07-7.09h90.35a7.08,7.08,0,0,1,7.09,7.09h0A7.08,7.08,0,0,1,291.17,242.23Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.17,242.23H278.83V228.05h12.34a7.08,7.08,0,0,1,7.09,7.09h0A7.08,7.08,0,0,1,291.17,242.23Z",
    style: {
      fill: "#2e353a",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.42,229.85a4.07,4.07,0,1,0,.19,5.75h0a4.05,4.05,0,0,0-.18-5.74Zm-.4,5.2a3.26,3.26,0,1,1-.15-4.62,3.27,3.27,0,0,1,.15,4.62l0,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.48,237.08a.65.65,0,0,0-.69-.14l-1.47-1.38a.4.4,0,0,0-.56,0l-.13.14a.42.42,0,0,0,0,.57l1.45,1.36a.69.69,0,0,0,.17.72l2.5,2.45a.88.88,0,0,0,1.24,0h0a.88.88,0,0,0,0-1.24Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--search-engines--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.3,285a5.83,5.83,0,0,0,3.21,3.22c1.13.46,2.64.36,4.38,1.34,3.93,2.21,13.74.24,20.85,1s16.69-7.11,16.69-7.11L390.64,285V257s-29.44,1.23-35.82-1.23-13.49-7.6-16.68-7.36-29.44,3.19-29.44,3.19L317.29,285Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310,172.1a29.63,29.63,0,1,0,32.71,26.19h0A29.61,29.61,0,0,0,310,172.1Zm5.88,53.08a23.77,23.77,0,1,1,21-26.25,23.77,23.77,0,0,1-21,26.25Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.84,170.41a29.63,29.63,0,1,0,32.71,26.19h0A29.64,29.64,0,0,0,309.84,170.41Zm5.88,53.08a23.77,23.77,0,1,1,21-26.25A23.77,23.77,0,0,1,315.72,223.49Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.5,
    y: 229.86,
    width: 7.17,
    height: 26.42,
    rx: 2.88,
    transform: "translate(-24.82 36.49) rotate(-6.32)",
    style: {
      fill: "#D26363",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.88,247l3-.32A4.93,4.93,0,0,1,325.3,251l4.49,40.61a6.3,6.3,0,0,1-5.57,6.95l-.2,0a6.29,6.29,0,0,1-6.95-5.57l-4.49-40.6a4.92,4.92,0,0,1,4.35-5.44Z",
    style: {
      fill: "#2e353a",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.24,280.84s-7.11.26-8.11,1.49-.82,5.51,1.11,6c4.92,1.29,15.38.54,15.79-.34s1.25-6-.91-6.55A52,52,0,0,0,321.24,280.84Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.19,270.92s-8.27-.31-9.56,1.18-1.54,7.06.64,7.9c5.56,2.13,18.07,1.3,18.64.2s1.81-6.81-.64-7.73S319.19,270.92,319.19,270.92Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318,259.72s-8.84-.34-10.22,1.26-1.65,7.54.68,8.44c6,2.28,19,2.28,19.61,1.1s2.25-8.16-.37-9.15S318,259.72,318,259.72Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.9,249.24s-8.84-.33-10.22,1.26-1.71,7.72.68,8.44,19,2.28,19.61,1.11,2.25-8.17-.37-9.16S312.9,249.24,312.9,249.24Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.85,278.65a14.91,14.91,0,0,1-4.45-2.06c-7.11-4.91-6.87-16.19-6.87-16.19l-1.71-.49a15.22,15.22,0,0,1-3.93-2.21,35.52,35.52,0,0,1,1,7.11A5.31,5.31,0,0,1,321,270c-2.21.25-3.19.49-3.93-2.45s-4.41-14.72-4.66-16.44c-.22-1.56,2.4-4.34,6.57-5,6.41.52,12.73,2.31,19.19,2.31a13,13,0,0,1,6.25,2.3",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.61,279.27a22.83,22.83,0,0,1-2.34,0",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.84,278.3a22.7,22.7,0,0,1-5.23,1",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 362.67,
    y1: 275.12,
    x2: 371.5,
    y2: 275.12,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 363.41,
    y1: 277.57,
    x2: 367.09,
    y2: 277.57,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.53,260.4s4.88,0,8.08-2.91",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.78,257.38a19.4,19.4,0,0,0-.83-3.92",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317,266.26s-.93-2.58.2-3.51,4.13-2.27,4.65-1.24,1.65,5.78,1.34,6.71l-.31.93",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "452.55 297.55 368 297.55 368 255.99 452.55 255.99",
    style: {
      fill: "#D26363",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 374.2,
    cy: 292.87,
    r: 1.9,
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.83,216.41a5.83,5.83,0,0,0,3.22-3.21c.46-1.13.35-2.63,1.34-4.38,2.2-3.92.24-13.73,1-20.85s-7.12-16.68-7.12-16.68l1.53-28.21h-28s1.22,29.44-1.23,35.81-7.6,13.5-7.36,16.69S206.42,225,206.42,225l33.36-8.59Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,223.69A29.63,29.63,0,1,0,153.21,191h-.07A29.63,29.63,0,0,0,127,223.69Zm53-5.89a23.78,23.78,0,1,1-26.27-21h0A23.79,23.79,0,0,1,180,217.8Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.27,223.87a29.62,29.62,0,1,0,26.19-32.71A29.62,29.62,0,0,0,125.27,223.87ZM178.35,218a23.77,23.77,0,1,1-26.25-21,23.77,23.77,0,0,1,26.25,21Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.72,
    y: 212.05,
    width: 26.42,
    height: 7.17,
    rx: 2.88,
    transform: "translate(-22.53 23.1) rotate(-6.32)",
    style: {
      fill: "#D26363",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.86,216.84l-.33-3a4.93,4.93,0,0,1,4.36-5.44l40.6-4.49a6.31,6.31,0,0,1,7,5.57h0l0,.2a6.31,6.31,0,0,1-5.57,7h0l-40.6,4.49A4.94,4.94,0,0,1,201.86,216.84Z",
    style: {
      fill: "#2e353a",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.69,212.48s.27,7.1,1.49,8.1,5.52.82,6-1.11c1.3-4.91.54-15.38-.34-15.78s-6-1.26-6.54.91A52,52,0,0,0,235.69,212.48Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.78,214.52s-.32,8.27,1.17,9.56,7.06,1.55,7.9-.64c2.14-5.56,1.3-18.07.2-18.63s-6.81-1.81-7.73.64S225.78,214.52,225.78,214.52Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.58,215.73s-.34,8.84,1.25,10.22,7.55,1.65,8.45-.69c2.28-5.94,2.28-19,1.1-19.6s-8.17-2.25-9.15.37S214.58,215.73,214.58,215.73Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.1,220.82s-.34,8.84,1.26,10.22,7.72,1.71,8.44-.69,2.28-19,1.1-19.61-8.16-2.24-9.15.38S204.1,220.82,204.1,220.82Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.12,185.08a17.44,17.44,0,0,1-2.68,11.23c-4.9,7.12-16.19,6.87-16.19,6.87l-.49,1.72a14.87,14.87,0,0,1-2.21,3.92,35.61,35.61,0,0,1,7.12-1,5.32,5.32,0,0,1,5.15,4.91c.25,2.21.49,3.19-2.45,3.92s-14.72,4.42-16.44,4.67c-1.56.22-4.34-2.4-5-6.57.53-6.41,2.32-12.74,2.32-19.19a13,13,0,0,1,2.3-6.26",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.16,179.88a20.15,20.15,0,0,1,.68,2.86",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229.97,
    y1: 171.04,
    x2: 229.97,
    y2: 162.21,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.42,
    y1: 170.31,
    x2: 232.42,
    y2: 166.63,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.25,203.18s0-4.88-2.91-8.08",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.24,208.94a19.38,19.38,0,0,0-3.92.82",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.12,216.68s-2.58.93-3.51-.21-2.27-4.13-1.24-4.64,5.78-1.65,6.71-1.34l.93.3",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "252.41 81.16 252.41 165.71 210.84 165.71 210.84 81.16",
    style: {
      fill: "#D26363",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.72,
    cy: 159.51,
    r: 1.9,
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198,367a5.8,5.8,0,0,1-3.21,3.22c-1.13.47-2.63.36-4.38,1.34-3.92,2.21-13.73.25-20.85,1s-16.68-7.11-16.68-7.11L124.64,367V339s29.44,1.23,35.82-1.22,13.49-7.61,16.68-7.36,29.44,3.19,29.44,3.19Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.25,254.16a29.63,29.63,0,1,1-32.71,26.19h0a29.62,29.62,0,0,1,32.7-26.18Zm-5.88,53.08a23.78,23.78,0,1,0-21-26.27h0A23.79,23.79,0,0,0,199.37,307.24Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.43,252.47a29.62,29.62,0,1,1-32.71,26.18,29.62,29.62,0,0,1,32.71-26.18Zm-5.88,53.08a23.78,23.78,0,1,0-21-26.27v0a23.78,23.78,0,0,0,21,26.25Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.96,
    y: 321.54,
    width: 26.42,
    height: 7.17,
    rx: 2.88,
    transform: "translate(-147.68 485.31) rotate(-83.68)",
    style: {
      fill: "#D26363",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.27,380.66l-.2,0a6.3,6.3,0,0,1-5.57-7l4.49-40.6a4.92,4.92,0,0,1,5.44-4.36l3,.33a4.93,4.93,0,0,1,4.36,5.44l-4.49,40.65a6.32,6.32,0,0,1-7,5.57Z",
    style: {
      fill: "#2e353a",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194,362.89s7.1.27,8.1,1.49.82,5.51-1.11,6c-4.91,1.3-15.38.54-15.78-.34s-1.26-6,.91-6.55A52,52,0,0,1,194,362.89Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.08,353s8.27-.32,9.56,1.17,1.55,7.06-.64,7.9c-5.56,2.13-18.07,1.3-18.63.2s-1.81-6.81.64-7.73S196.08,353,196.08,353Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.29,341.77s8.84-.33,10.22,1.26,1.65,7.55-.68,8.44c-6,2.29-19,2.28-19.61,1.11s-2.25-8.17.37-9.16S197.29,341.77,197.29,341.77Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.38,331.3s8.84-.34,10.22,1.25,1.71,7.73-.69,8.45-19,2.27-19.61,1.1-2.24-8.17.38-9.15S202.38,331.3,202.38,331.3Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,361.37a16.77,16.77,0,0,0,9.85-2.73c7.12-4.91,6.87-16.19,6.87-16.19l1.72-.49a14.87,14.87,0,0,0,3.92-2.21,35.52,35.52,0,0,0-1,7.11,5.33,5.33,0,0,0,4.91,5.16c2.21.24,3.19.49,3.93-2.46s4.41-14.72,4.66-16.43-2.4-4.35-6.57-5c-6.41.53-12.74,2.32-19.19,2.32a13.08,13.08,0,0,0-6.26,2.29",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.44,360.36a22.36,22.36,0,0,0,4.29.87",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 152.6,
    y1: 357.17,
    x2: 143.77,
    y2: 357.17,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 151.87,
    y1: 359.62,
    x2: 148.19,
    y2: 359.62,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.74,342.45s-4.88,0-8.08-2.91",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.5,339.43a19.38,19.38,0,0,1,.82-3.92",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.24,348.31s.93-2.58-.21-3.51-4.13-2.27-4.64-1.24-1.65,5.79-1.34,6.71l.31.93",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "62.72 379.61 147.27 379.61 147.27 338.04 62.72 338.04",
    style: {
      fill: "#D26363",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.17,374.92a1.9,1.9,0,1,0,1.9-1.9h0A1.9,1.9,0,0,0,139.17,374.92Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.79d5772e26ee1c0375003d36db88f76a.svg";
export { ForwardRef as ReactComponent };